import Menu from "../menu/PublicMenu.jsx";

const UserLayout = ({ children }) => {
  return (
    <>
      <Menu />
      <div className="content">{children}</div>
    </>
  );
};

export default UserLayout;
